import { useRef, useState, createElement, useCallback, useEffect } from 'react';
import './index.scss';
import { default as GoodItem } from './components/good-item';
import checkboxPng from "../../assets/icon/shop/checkbox.png";
const ShoppingCart = ({ dataList, handleOnLoad, handleOnSubmit, handleOnDelete, handleGoodUpdate, isLogin, ...otherProps }) => {
    const _otherProps = otherProps || {};
    dataList = dataList.map(item => ({
        ...item,
        checked: item.checked || false,
        isUpdate: item.isUpdate || false,
        price: item.productPromotionPrice || item.productPrice || 0,
    }));
    const [isEdit, setIsEdit] = useState(false);
    const [list, setList] = useState(dataList);
    const isBeforeUnmount = useRef(false);
    const [checked, setChecked] = useState(false);
    const [items, setItems] = useState(dataList);
    useEffect(() => {
        const initialItems = (list || []).map(item => ({
            ...item,
            checked: item.checked || false,
            isUpdate: item.isUpdate || false,
            price: item.productPromotionPrice || item.productPrice || 0,
        }));
        setItems(initialItems);
        console.log('items', items, list);
    }, [list]);
    const updateEdit = () => {
        setIsEdit(!isEdit);
    };
    const handleItemUpdate = useCallback((index, updatedItem) => {
        const newList = [...list];
        newList[index] = updatedItem;
        setList(newList);
    }, [list]);
    const selectDataList = useCallback(() => {
        return items.filter(item => item.checked);
    }, [items]);
    const localTotal = useCallback(() => {
        let num = 0;
        if (selectDataList().length > 0) {
            num = selectDataList().reduce((sum, item) => sum + item.amount, 0);
        }
        console.log('num', num);
        return num;
    }, [selectDataList]);
    const localTotalPrice = useCallback(() => {
        return selectDataList().reduce((sum, item) => sum + item.price * item.amount, 0);
    }, [selectDataList]);
    const onAddOrSubtract = (type, item) => {
        console.log('type', type);
        if (handleGoodUpdate) {
            handleGoodUpdate(type, item);
        }
    };
    const checkChange = useCallback((item) => {
        const shopList = items.map(data => {
            if (data.id == item.id) {
                data.checked = item.checked;
            }
            return data;
        });
        setItems(shopList);
        setChecked(shopList.every(oItem => oItem.checked === true));
    }, []);
    const checkAllChange = useCallback((newValue) => {
        setChecked(newValue);
        const shopList = items.map(data => {
            data.checked = newValue;
            return data;
        });
        setItems(shopList);
        console.log('切换', items);
    }, []);
    const submit = useCallback(() => {
        console.log('提交购物车', selectDataList());
        if (handleOnSubmit) {
            handleOnSubmit(selectDataList());
        }
    }, []);
    const removeShopCar = useCallback(() => {
        console.log('删除购物车商品');
        if (handleOnDelete) {
            handleOnDelete(selectDataList());
        }
    }, []);
    console.log('dataList', isBeforeUnmount);
    return (createElement("div", { className: "shopping-cart", ..._otherProps },
        createElement("div", { style: { padding: '12.5px 12.5px 68px 12.5px' } },
            items.length > 0 && (createElement("div", { className: "header" },
                createElement("div", { className: "number" },
                    "\u6570\u91CF\uFF1A",
                    list.length),
                createElement("div", { className: "text", onClick: updateEdit, style: { color: isEdit ? '#EC5C29' : '#333333' } }, isEdit ? '完成' : '管理'))),
            createElement("div", null, list.map((item, index) => (createElement(GoodItem, { key: index, item: item, isEdit: isEdit, onAddOrSubtract: onAddOrSubtract, onUpdateItem: (updatedItem) => handleItemUpdate(index, updatedItem), onCheckChange: checkChange }))))),
        createElement("div", { className: "footer", style: { display: items.length > 0 ? 'block' : 'none' } }, !isEdit ? (createElement("div", { className: "box" },
            createElement("div", { className: "left" },
                checked ? (createElement("div", { className: "checkbox-img" },
                    createElement("img", { className: "checkbox-img", src: checkboxPng, onClick: () => checkAllChange(false) }))) : (createElement("div", { className: "checkbox2", onClick: () => checkAllChange(true) })),
                createElement("div", { className: "text" }, "\u5168\u9009")),
            createElement("div", { className: "footer-info" },
                createElement("div", { className: "text" },
                    "\u5DF2\u9009",
                    localTotal(),
                    "\u4EF6,",
                    createElement("span", null, "\u5408\u8BA1\uFF1A")),
                createElement("div", { className: "price" },
                    "\u00A5",
                    localTotalPrice().toFixed(2)),
                createElement("div", { className: "btn", onClick: submit }, "\u7ED3\u7B97"))))
            : (createElement("div", { className: "box box2" },
                createElement("div", { className: "left" },
                    checked ? (createElement("div", { className: "checkbox-img" },
                        createElement("img", { className: "checkbox-img", src: checkboxPng, onClick: () => checkAllChange(false) }))) : (createElement("div", { className: "checkbox2", onClick: () => checkAllChange(true) })),
                    createElement("div", { className: "text" }, "\u5168\u9009")),
                createElement("div", { className: "footer-info" },
                    createElement("div", { className: "btn", onClick: removeShopCar }, "\u5220\u9664")))))));
};
ShoppingCart.displayName = 'ShoppingCart';
export default ShoppingCart;
